import Price from '~/utils/Price/Price';

import CountryOfOrigin from './CountryOfOrigin';

export interface RawCountryOfOrigin {
	nationality: string | null;
	exFactoryPrice: { value: string; currency: string } | null;
	wholesalePrice: { value: string; currency: string } | null;
	publicPrice: { value: string; currency: string } | null;
}

export default function mapCountryOfOrigin(countryOfOrigin: RawCountryOfOrigin): CountryOfOrigin {
	return new CountryOfOrigin(
		countryOfOrigin.nationality,
		countryOfOrigin.exFactoryPrice !== null
			? new Price(countryOfOrigin.exFactoryPrice.value, countryOfOrigin.exFactoryPrice.currency)
			: null,
		countryOfOrigin.wholesalePrice !== null
			? new Price(countryOfOrigin.wholesalePrice.value, countryOfOrigin.wholesalePrice.currency)
			: null,
		countryOfOrigin.publicPrice !== null
			? new Price(countryOfOrigin.publicPrice.value, countryOfOrigin.publicPrice.currency)
			: null
	);
}
